import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import FeatherIcon from "feather-icons-react";
import './style.scss';

export const Input = (params) => {
  return (
    <input
        type={params?.type || 'text'}
        step={params?.step}
        className={`form-input ${params?.className || ''}`}
        placeholder={params?.placeholder || ''}
        onBlur={params?.onBlur || (() => {})}
        onChange={params?.onChange || (() => {})}
        onInput={params?.onInput || (() => {})}
        ref={(ref) => params?.useRef ? params.useRef.current[params?.id || 'input'] = ref : null}
        disabled={params?.disabled || false}
        defaultValue={params?.defaultValue || ''}
    />
  )
}


export const InputPassword = (params) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
        <>
        <input
            name={'password'}
            type={showPassword === true ? 'text' : 'password'}
            className="form-input"
            placeholder={params?.placeholder || "Tu contraseña"}
            ref={(ref) => params?.useRef ? params.useRef.current[params?.id || 'password'] = ref : null}
            disabled={params?.disabled || false}
            defaultValue={params?.defaultValue || ''}
        />
        <div style={{ position: 'relative' }}>
        <button
            type="button"
            onClick={() => setShowPassword((value) => !value)}
            className="forn-input-eye"
            disabled={params?.disabled || false}
          >
            {showPassword 
                ? <FeatherIcon 
                    icon="eye"
                    size={15}
                    strokeWidth={2.5}
                />
                : <FeatherIcon 
                    icon="eye-off"
                    size={15}
                    strokeWidth={2.5}
                />
            }
        </button>
        </div>
        </>
    )
}

export const TextArea = (params) => {
  return (
    <textarea
        type={params?.type || 'text'}
        className={`form-input ${params?.className || ''}`}
        placeholder={params?.placeholder || ''}
        onBlur={params?.onBlur || (() => {})}
        onChange={params?.onChange || (() => {})}
        onInput={params?.onInput || (() => {})}
        ref={(ref) => params?.useRef ? params.useRef.current[params?.id || 'input'] = ref : null}
        disabled={params?.disabled || false}
        defaultValue={params?.defaultValue || ''}
    />
  )
}

export const Label = (params) => {
    return (
        <label className={`form-label ${params.className || ''}`}>{params?.value || '' }</label>
    )
  }